import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { MailCheck, XCircle } from 'lucide-react';
import AuthShell from '../../components/AuthShell';
import { validateEmailTokenApi, confirmEmailApi } from '../../api';
import { isAuthenticated, patchUser } from '../../auth/storage';

const MSG = {
    usado: 'Este link já foi usado. Seu email provavelmente já está confirmado.',
    expirado: 'Este link expirou. Peça um novo pelo painel.',
    invalido: 'Link inválido.',
};

export default function ConfirmarEmail() {
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const [estado, setEstado] = useState('checking'); // checking|success|erro
    const [codigo, setCodigo] = useState('invalido');
    const logado = isAuthenticated();

    useEffect(() => {
        let vivo = true;
        if (!token) { setEstado('erro'); setCodigo('invalido'); return; }
        (async () => {
            try {
                const val = await validateEmailTokenApi({ token });
                if (!vivo) return;
                if (!val?.data?.valid) { setCodigo(val?.data?.error || 'invalido'); setEstado('erro'); return; }
                await confirmEmailApi({ token });
                if (!vivo) return;
                if (logado) patchUser({ email_verificado_at: new Date().toISOString() });
                setEstado('success');
            } catch (err) {
                if (!vivo) return;
                setCodigo(err?.response?.data?.error || 'invalido');
                setEstado('erro');
            }
        })();
        return () => { vivo = false; };
    }, [token, logado]);

    if (estado === 'checking') {
        return <AuthShell><div className="ueb-auth-card pcenter"><span className="pspin" style={{ color: 'var(--p-accent)' }} /><p className="ueb-auth-sub" style={{ marginTop: 14 }}>Confirmando seu email…</p></div></AuthShell>;
    }

    if (estado === 'success') {
        return (
            <AuthShell>
                <div className="ueb-auth-card pcenter">
                    <div className="ueb-auth-ico is-success"><MailCheck size={40} /></div>
                    <h1>Email confirmado!</h1>
                    <p className="ueb-auth-sub">Tudo certo. Seu email foi verificado com sucesso.</p>
                    <Link className="pbtn pbtn--primary pbtn--block" to={logado ? '/' : '/login'}>
                        {logado ? 'Ir para o início' : 'Ir para o login'}
                    </Link>
                </div>
            </AuthShell>
        );
    }

    return (
        <AuthShell>
            <div className="ueb-auth-card pcenter">
                <div className="ueb-auth-ico is-danger"><XCircle size={40} /></div>
                <h1>Link indisponível</h1>
                <p className="ueb-auth-sub">{MSG[codigo] || MSG.invalido}</p>
                <Link className="pbtn pbtn--primary pbtn--block" to={logado ? '/' : '/login'}>
                    {logado ? 'Ir para o início' : 'Ir para o login'}
                </Link>
            </div>
        </AuthShell>
    );
}
